import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { map, retry } from "rxjs/operators";
import { environment } from "environments/environment";
import { Alert, AlertAdapter } from "../models/alert.model";

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  private baseUrl = environment.websiteApiEndpoint;

  constructor(
    private http: HttpClient,
    private alertAdapter: AlertAdapter
  ) { }

  private getHeaders(): HttpHeaders {
    return new HttpHeaders(
      {
        'Content-Type': 'application/json'
      }
    );
  }

  /**
   * Update qriska alert status
   * @param alert alert with updated status (NEW/IN PROGRESS/TERMINATED/IGNORED/ARCHIVED)
   * @returns alert
   */
  public updateStatus(alert: Alert): Observable<Alert> {
    const path: string = "qriskalert/status";
    const body: any = {
      organization_uid: alert.organization_uid,
      alert_uid: alert.uid,
      status: alert.status
    }
    return this.http.post(this.baseUrl + path, body, {headers: this.getHeaders()}).pipe(retry(3), map((data: any) => this.alertAdapter.adapt(data.alert)));
  }

  /**
   * Get qriska alerts (static organization/model from prod)
   * @param limit number of alerts to retrieve
   * @returns Alert array
   */
  public getAlerts(limit: number): Observable<Alert[]> {
    const path: string = "qriskalerts?limit=" + limit;
    return this.http.get(this.baseUrl + path, {headers: this.getHeaders()}).pipe(retry(3), map((data: any) => data.map((item: any) => this.alertAdapter.adapt(item))));
  }
}